export default function Home() {

  const init = () => {
    initMainHeroSlider();
    initHomeAboutParallax();
    initProductsFilter();
  };

  const initMainHeroSlider = () => {
    const AUTOPLAY_DURATION = 5000;
    const elmMainHero = document.querySelector('.js-main-hero');

    if (!elmMainHero) return;

    if (elmMainHero.swiper) return;

    const elmPagination = elmMainHero.querySelector('.swiper-pagination');
    const slides = elmMainHero.querySelectorAll('.swiper-wrapper > .swiper-slide');
    const REAL_SLIDES_COUNT = slides.length;
    const HAS_SINGLE_SLIDE = REAL_SLIDES_COUNT <= 1;

    const elmSection = elmMainHero.closest('.main-hero');

    let activeVimeo = null;
    let onVideoEnded = null;

    const isVimeoSlide = (slide) => !!slide?.querySelector('iframe[src*="vimeo.com"]');

    // 👇 Verifica se é só um slide e ele é vídeo
    if (HAS_SINGLE_SLIDE && isVimeoSlide(slides[0])) {
      elmSection?.classList.add('is-only-slide-video');
    } else {
      elmSection?.classList.remove('is-only-slide-video');
    }

    const teardownVideo = () => {
      if (!activeVimeo) return;
      try {
        if (onVideoEnded) {
          activeVimeo.off('ended', onVideoEnded);
        }
        activeVimeo.pause?.().catch(() => {});
      } catch (e) {}
      onVideoEnded = null;
      activeVimeo = null;
    };

    const handleSlide = (sw)=>{
      const slide = sw.slides[sw.activeIndex];

      if (!isVimeoSlide(slide)) {
        sw.allowSlideNext = true;
        sw.params.autoplay.delay = AUTOPLAY_DURATION;
        if (!sw.autoplay.running) sw.autoplay.start();
        return;
      }

      const iframe = slide.querySelector('iframe[src*="vimeo.com"]');
      if (!iframe || typeof Vimeo === 'undefined') return;

      // Para tudo enquanto o vídeo roda
      sw.autoplay.stop();
      // sw.allowSlideNext = false; // bloqueia avanço até o fim do vídeo
      teardownVideo();

      activeVimeo = new Vimeo.Player(iframe);

      // Evita loop “silencioso” do player
      activeVimeo.setLoop(false).catch(()=>{});

      activeVimeo.setVolume(0).catch(()=>{});

      activeVimeo.setCurrentTime(0).catch(()=>{});
      activeVimeo.play().catch(()=>{});

      onVideoEnded = () => {
        console.log('onVideoEnded');
        // ao terminar, libera o avanço e vai para o próximo
        // sw.allowSlideNext = true;
        sw.slideNext();

        // limpa e volta o autoplay para os próximos slides de imagem
        teardownVideo();
        sw.params.autoplay.delay = AUTOPLAY_DURATION;
        sw.autoplay.start();
      };

      // previne duplicidade de listeners
      activeVimeo.off('ended');
      activeVimeo.on('ended', onVideoEnded);
    };

    new Swiper(elmMainHero, {
      loop: REAL_SLIDES_COUNT > 1,
      speed: 800,
      effect: 'fade',
      slidesPerView: 1,
      autoplay: HAS_SINGLE_SLIDE
      ? false
      : {
          delay: AUTOPLAY_DURATION,
          disableOnInteraction: false,
        },
      navigation: false,
      pagination: {
        el: elmPagination,
        clickable: true,
        type: 'bullets',
      },
      on: {
        init() {
          handleSlide(this);
        },
        slideChangeTransitionStart() {
          teardownVideo();
        },
        slideChangeTransitionEnd() {
          handleSlide(this);
        },
        beforeDestroy() {
          teardownVideo();
        },
      }
    });
  };

  const initProductsSlider = () => {
    const elmSlider = document.querySelector('.js-home-products');

    if(elmSlider) {
      new Swiper(elmSlider, {
        slidesPerView: 1.33,
        spaceBetween: 16,
        breakpoints: {
          768: {
            slidesPerView: 3,
          }
        }
      });
    }
  };

  const initHomeAboutParallax = () => {
    const sectionElement = document.querySelector('.home-about');
    if (!sectionElement) return;

    const wrapperElement = sectionElement.querySelector('.wrapper');
    const imageElements = Array.from(wrapperElement.children).filter(el => el.tagName === 'IMG');
    const contentElement = sectionElement.querySelector('.home-about__wrap');

    // --- Animação de entrada do conteúdo principal ---
    if (contentElement) {
      gsap.fromTo(
        contentElement,
        { autoAlpha: 0, y: 24 },
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.9,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: contentElement,
            start: 'top 80%',
            toggleActions: 'play none none reverse',
          },
        }
      );
    }

    // --- Helpers de leitura de dados ---
    const getNumericData = (element, attribute, fallback) => {
      const value = parseFloat(element.dataset[attribute]);
      return Number.isFinite(value) ? value : fallback;
    };

    const getDirection = element =>
      element.dataset.direction === 'down' ? 'down' : 'up';

    const clampRotation = gsap.utils.clamp(-45, 45);

    // --- Função principal de montagem do efeito ---
    const createParallaxEffect = ({
      intensityFactor = 0.7,
      maxRotation = 14,
      isMobile = false,
    }) => {
      imageElements.forEach(image => {
        const baseSpeed = getNumericData(image, 'speed', 0.5);
        const baseRotation = getNumericData(image, 'rotate', 0);
        const finalSpeed = isMobile
          ? getNumericData(image, 'mobileSpeed', baseSpeed * 0.6)
          : baseSpeed;
        const finalRotation = isMobile
          ? getNumericData(image, 'mobileRotate', baseRotation * 0.6)
          : baseRotation;

        const direction = getDirection(image);
        const sectionHeight = Math.max(sectionElement.offsetHeight, window.innerHeight);
        const movementDistance = sectionHeight * finalSpeed * intensityFactor;

        const startY = direction === 'up' ? movementDistance : -movementDistance;
        const endY = direction === 'up' ? -movementDistance : movementDistance;

        // Garante que a animação não seja duplicada
        gsap.killTweensOf(image);
        gsap.set(image, { y: 0, rotate: 0 });

        // Cria o parallax com rotação
        gsap.fromTo(
          image,
          {
            y: startY * 0.4,
            rotate: clampRotation(-finalRotation * 0.25),
          },
          {
            y: endY * 0.4,
            rotate: clampRotation(
              Math.max(Math.min(finalRotation, maxRotation), -maxRotation)
            ),
            ease: 'none',
            scrollTrigger: {
              trigger: sectionElement,
              start: 'top bottom',
              end: 'bottom top',
              scrub: true,
              invalidateOnRefresh: true,
              // markers: true, // para debug
            },
          }
        );
      });
    };

    // --- Configuração responsiva e acessibilidade ---
    ScrollTrigger.matchMedia({
      '(prefers-reduced-motion: reduce)': () => {
        ScrollTrigger.getAll().forEach(st => st.kill());
        gsap.set([imageElements, contentElement], { clearProps: 'all' });
      },

      '(max-width: 767px)': () => {
        // Mobile → menos movimento e rotação
        createParallaxEffect({
          intensityFactor: 0.35,
          maxRotation: 10,
          isMobile: true,
        });
      },

      '(min-width: 768px)': () => {
        // Desktop / Tablet → efeito completo
        createParallaxEffect({
          intensityFactor: 0.7,
          maxRotation: 14,
          isMobile: false,
        });
      },
    });

    // --- Atualiza os cálculos após o load e resize ---
    const refreshScrollTriggers = () => ScrollTrigger.refresh();
    let call;
    window.addEventListener('load', refreshScrollTriggers, { once: true });
    window.addEventListener('resize', () => {
      if (call) call.kill();
      call = gsap.delayedCall(0.15, () => ScrollTrigger.refresh());
    });
  };

  const initProductsFilter = function() {
    let isProductsLoading = false;
    let isRevealed = false;
    const itemsContainer = document.querySelector('.home-products__items');
    const cards = document.querySelectorAll('.home-products .card-product'),
          cardsAll = document.querySelector('.home-products .btn-all');

    const revealItems = () => {
      if (isRevealed) return;
      isRevealed = true;
      if (itemsContainer) itemsContainer.classList.remove('is-hidden');
      initProductsSlider();
    };

    const setLoadingState = function(isLoading) {
      isProductsLoading = isLoading;

      if(cards) {
        cards.forEach(c => c.classList.toggle('loading', isLoading));
      }

      if(cardsAll) {
        cardsAll.classList.toggle('loading', isLoading);
      }

    }

    const handleCatFilter = function(e) {
      if(!isProductsLoading) {
        revealItems();

        const btn = e.currentTarget;
        const url = btn.dataset.url;
        const activeBtn = document.querySelector('.home-products .js-product-categories .button-category.is-active');
        if(activeBtn) {
          activeBtn.classList.remove('is-active');
        }

        btn.classList.add('is-active');

        setLoadingState(true);

        fetchProducts(url);
      }

    }

    const fetchProducts = async function(url) {
      const resp = await fetch(url);
      const json = await resp.json();
      if(json) {
        cards.forEach((c,i) => {
          if(json.data[i]) {
            c.classList.remove('inactive');

            c.setAttribute('href', json.data[i].url);
            c.querySelector('.card-product__title').innerHTML = json.data[i].title;
            c.querySelector('img').setAttribute('src', json.data[i].image);
            c.querySelector('img').setAttribute('alt', json.data[i].title);

          } else {
            c.classList.add('inactive');
          }
        });

        cardsAll.setAttribute('href', json.all);
      }
      setTimeout(function(){
        setLoadingState(false);
      }, 100);
    }

    const catBtns = document.querySelectorAll('.home-products .js-product-categories .button-category');
    if(catBtns) {
      catBtns.forEach(btn => {
        btn.addEventListener('mouseenter', handleCatFilter);
      });
    }

  }

  init();
}
